// extracted by mini-css-extract-plugin
export default {"forceFilterInput":"ForcesList_forceFilterInput__YDnrh","forceListContainer":"ForcesList_forceListContainer__gFLmw"};